module.exports = {"data":{"generalJson":{"card":"Detector","abilityText":"Opposing stealth and invisible forces are visible to you.","rulings":[{"ruling":null,"author":null,"date":null}]},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"detector"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/ruling-detector.json
// module id = 1256
// module chunks = 237923725950639